import React, { useEffect } from 'react';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import { useForm } from 'react-hook-form';

export default ({ classes, onSubmit, submitErrors }) => {
  const { register, handleSubmit, setError, watch, errors } = useForm();

  useEffect(() => {
    submitErrors.map((error) => {
      return setError(error.param, {
        type: 'manual',
        message: error.msg,
      });
    });
  }, [submitErrors, setError]);

  return (
    <Container component="main" maxWidth="xs">
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              inputRef={register({
                required: 'required',
                minLength: { value: 6, message: 'Password must be at least 6 characters long' },
                validate: (value) => {
                  return value === watch('confirm_password') || "Passwords don't match";
                },
              })}
              variant="outlined"
              fullWidth
              name="password"
              label="New Password"
              type="password"
              id="password"
              error={errors.hasOwnProperty('password')}
              helperText={errors.password && errors.password.message}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              inputRef={register({ required: 'required', minLength: 6 })}
              variant="outlined"
              fullWidth
              name="confirm_password"
              label="Confirm New Password"
              type="password"
              id="confirm_password"
              error={errors.hasOwnProperty('confirm_password')}
              helperText={errors.confirm_password && errors.confirm_password.message}
            />
          </Grid>
        </Grid>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
        >
          Reset Password
        </Button>
        <Grid container justify="center">
          <Grid item>
            <Link href="/#/login" variant="body2">
              Back to Login
            </Link>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};
